// extracted by mini-css-extract-plugin
export default {"suffixStyle":"payment_suffixStyle__HT4+C","labelStyle":"payment_labelStyle__lVQTJ","priceStyle":"payment_priceStyle__7R+XC","priceTable":"payment_priceTable__VFtrY"};